import React from 'react';
import { Sparkles } from 'lucide-react';

export const WeeklyPromptCard = ({ weeklyPrompt, onRespond }) => {
  if (!weeklyPrompt) return null;
  
  return (
    <div 
      className="p-6 rounded-2xl mb-6"
      style={{ 
        background: 'linear-gradient(135deg, rgba(201,168,76,0.1) 0%, rgba(232,180,184,0.05) 100%)',
        border: '1px solid rgba(201,168,76,0.2)'
      }}
      data-testid="weekly-prompt-card"
    >
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-4 h-4" style={{ color: '#C9A84C' }} />
        <span 
          className="text-xs tracking-wider"
          style={{ color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}
        >
          THIS WEEK'S PROMPT {weeklyPrompt.theme && `· ${weeklyPrompt.theme.toUpperCase()}`}
        </span>
      </div>
      <p 
        className="text-lg mb-4 leading-relaxed"
        style={{ color: '#1A1A2E', fontFamily: 'Cormorant Garamond, serif' }}
      >
        "{weeklyPrompt.prompt_text}"
      </p>
      <div className="flex items-center justify-between">
        <span style={{ color: '#8A8798', fontSize: '13px', fontFamily: 'Jost, sans-serif' }}>
          {weeklyPrompt.response_count} reflections shared
        </span>
        {!weeklyPrompt.user_has_responded && (
          <button
            onClick={onRespond}
            className="text-sm transition-all hover:scale-105"
            style={{ color: '#A9756B', fontFamily: 'Jost, sans-serif' }}
            data-testid="respond-to-prompt"
          >
            Share your reflection →
          </button>
        )}
      </div>
    </div>
  );
};
